import { API_BASE } from "./api";

/**
 * Convert a stored photo/logo URL into a browser-usable URL.
 * Internal paths starting with /api/ are proxied via REACT_APP_BACKEND_URL
 * and get the auth token appended as a query param (since <img> tags
 * cannot send Authorization headers). External http(s) URLs are returned as-is.
 */
export function resolveMediaUrl(u) {
  if (!u) return "";
  if (u.startsWith("http://") || u.startsWith("https://") || u.startsWith("data:")) return u;
  if (u.startsWith("/api/")) {
    const token = localStorage.getItem("wahdat_token");
    const sep = u.includes("?") ? "&" : "?";
    const base = process.env.REACT_APP_BACKEND_URL || "";
    return `${base}${u}${sep}auth=${encodeURIComponent(token || "")}`;
  }
  return u;
}
